/**
 * Meta WhatsApp UI design preview.
 * Keep FORCE=false for staging/production.
 * Local hosts (localhost / *.localhost) still get demo UI.
 */
export const META_WA_FORCE_DESIGN_DEMO = false

export const isMetaWaDesignDemo = () => {
  if (META_WA_FORCE_DESIGN_DEMO) return true
  if (typeof window === "undefined") return false
  const h = window.location.hostname
  return (
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "0.0.0.0" ||
    h.endsWith(".localhost")
  )
}

/** Dummy approved templates for local workflow / UI design review */
export const META_WA_DEMO_TEMPLATES = [
  {
    id: "demo-tpl-1",
    name: "order_confirmation",
    language: "en_US",
    category: "UTILITY",
    status: "APPROVED",
    body_preview:
      "Hello {{1}}, your order {{2}} has been confirmed successfully.",
    components: [
      {
        type: "BODY",
        text: "Hello {{1}}, your order {{2}} has been confirmed successfully.",
      },
    ],
    _demo: true,
  },
  {
    id: "demo-tpl-2",
    name: "welcome_offer",
    language: "en_US",
    category: "MARKETING",
    status: "APPROVED",
    body_preview: "Hi {{1}}, welcome to {{2}}! How can we help you today?",
    components: [
      {
        type: "BODY",
        text: "Hi {{1}}, welcome to {{2}}! How can we help you today?",
      },
    ],
    _demo: true,
  },
  {
    id: "demo-tpl-3",
    name: "shipping_update",
    language: "en_US",
    category: "UTILITY",
    status: "APPROVED",
    body_preview: "Hi {{1}}, your order {{2}} is out for delivery.",
    components: [
      { type: "HEADER", format: "IMAGE" },
      {
        type: "BODY",
        text: "Hi {{1}}, your order {{2}} is out for delivery.",
      },
    ],
    _demo: true,
  },
]
